import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TRANSLATION_KEYS } from '../constants';
import { noResultsStyles } from '../styles';

interface NoResultsMessageProps {
  show: boolean;
}

/**
 * Component to display a message when no search results are found
 */
export const NoResultsMessage: React.FC<NoResultsMessageProps> = ({ show }) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <Box sx={noResultsStyles}>
      <Typography variant="body1">
        {t(TRANSLATION_KEYS.SEARCH.NO_RESULTS)}
      </Typography>
    </Box>
  );
};
